import React, { FC } from 'react';
import { Box, Text } from '@sparknz/spark-pattern-library';

import GenericErrorBanner from 'components/shop/MobilePlans/components/GenericErrorBanner';
import {
  RelatedOfferDetails,
  SelectedPlan,
} from 'components/shop/MobilePlans/typings/plans';
import AddRelatedOfferStep from '../AddRelatedOfferStep';
import { buildDescriptionText } from './EligibleMessageStepHelpers';

const STEP_TITLE = 'You’re eligible!';
const REGION_ID = 'eligibleMessageActionLayer';
const TRACKING_EVENT_NAME = 'Eligible Message Action Layer';

interface EligibleMessageStepProps {
  selectedPlan: SelectedPlan;
  kidsPlan: RelatedOfferDetails;
  companionPlan?: RelatedOfferDetails;
  isAddingBundles: boolean;
  onNext(): void;
  onSkip(): void;
}

const EligibleMessageStep: FC<EligibleMessageStepProps> = ({
  isAddingBundles,
  selectedPlan,
  kidsPlan,
  companionPlan,
  onNext,
  onSkip,
}) => {
  const descriptionText = buildDescriptionText({
    selectedPlan,
    kidsPlan,
    companionPlan,
  });

  if (!descriptionText) {
    return <GenericErrorBanner />;
  }

  return (
    <AddRelatedOfferStep
      regionId={REGION_ID}
      eventName={TRACKING_EVENT_NAME}
      isAddingBundles={isAddingBundles}
      title={<Text variant="subheadingM">{STEP_TITLE}</Text>}
      description={
        <Box mb="s4">
          <Text variant="bodySMedium">{descriptionText}</Text>
        </Box>
      }
      onNext={onNext}
      onSkip={onSkip}
    />
  );
};

export default EligibleMessageStep;
